export const extractCode = (text?: string | null) => {
  return (text ?? "").replaceAll(/_*[^_|]*｜/g, "｜").replace(/_.*/, "")
}
